<template>
    <div :class="css.container">
        <div :class="css.search">
            <!-- * 标题 -->
            <h1 :class="css.name" class="font-bold font-variable">Rare Disease Data Center</h1>
            <!-- * 搜索框-->
            <SelectSearch :class="css.input" v-model="keyword" @search="methods.next" />
        </div>
        <div :class="css.routes">
            <div :class="css.content" class="container">
                <ProjectRoute :class="css.route" to="/" target="_self">{{ $t("Home.Name") }}</ProjectRoute>
                <UiIcon :class="css.arrow" name="arrow" />
                <ProjectRoute :class="[css.route, !mode && css.active]" target="_self" :to="href">{{ $t("SearchResult") }}</ProjectRoute>
                <template v-if="mode">
                    <ui-icon :class="css.arrow" name="arrow" />
                    <div :class="css.active">
                        {{ $t("Layout.TypeDatabase", { type: $route.meta.name }) }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 公共组件
import { SelectSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组合函数
const { refs, methods, computeds } = useComposable();
const { href } = computeds;
const { mode, keyword } = refs;

//* 组件初始化
methods.init();
</script>
